'use strict'
const joi = require('@hapi/joi')

require('dotenv').config({ silent: true })

const envVarsSchema = joi.object({
  VUE_APP_API_URL: joi.string().required(),
}).unknown().required()

const { error, value: envVars } = envVarsSchema.validate(process.env)
if (error) {
  console.log(`Config validation error: ${error.message}`)
  process.exit(500)
}

const config = {
  api_url: envVars.VUE_APP_API_URL,

}

module.exports = config
